import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type BucketedRegimeByQuantilesProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;
  fullScreen: boolean;
  title: string;

  context?: ts.types.signal.SignalAnalysisContext;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'signal_bucketed_regime_analysis_by_quantiles', string>;
};

const BucketedRegimeByQuantiles = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  fullScreen,
  widgetPaths,
  mode,
  params,
  setParams,
  context,
  title,
}: BucketedRegimeByQuantilesProps) => {
  const renderJobComponent = () => (
    <>
      <Chart
        id={id}
        readOnly={readOnly}
        widgetKey={widgetKey}
        fullScreen={fullScreen}
        loadWidgetData={loadWidgetData}
        file={widgetPaths['signal_bucketed_regime_analysis_by_quantiles']}
        params={params as Params}
        context={context}
        title={title}
      />
    </>
  );

  return (
    <>{mode == 'edit' ? <Form params={params} setParams={setParams} context={context} /> : renderJobComponent()}</>
  );
};

export default BucketedRegimeByQuantiles;
